/**
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Organization add/edit page
  Date: April 04, 2020
**/

import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Grid,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { useStoreState, useStoreActions } from 'easy-peasy';
import {
  PACKAGES,
  globalPageTypeEntity,
} from '../../constants/applicationConstants';
import DisplayBreadcrumbs from '../../components/displayBreadcrumbs/displayBreadcrumbs';
import OrgsUsers from '../../components/orgsUsers/orgsUsers';
import OrgsProducts from '../../components/orgsProduct/orgsProduct';
import DisplayDate from '../../components/customListing/displayDate/displayDate';
import { useHistory } from 'react-router-dom';
import { PopupModal } from '../../submodule';
import { OrganizationForm } from './organizationForm';
/** STYLES HERE * */
const TAB_LIST = ['Users', 'Products'];
export const OrganizationDetailPage = (props) => {
  /** CALL ACTIONS AND STATE EASYPEASY * */
  const history = useHistory();
  const [orgAction, userAction] = useStoreActions((actions) => [
    actions.organization,
    actions.userList,
  ]);
  const orgState = useStoreState((state) => state.organization);
  const [currentTab, setCurrentTab] = useState(0);
  const [open, setOpen] = React.useState(false); //orgsFormData

  const breadcrumbsNav = [
    {
      title: 'Tenants',
      link: '/organization',
    },
    {
      title: 'Tenants Details',
      link: '',
    },
  ];

  const getDetails = (id) => {
    orgAction.getOrgs(id).then(function (response) {
      if (response.payload && response.payload.error) {
        setEmptyRecord(true);
      }
    });
  };
  const a11yProps = (index) => {
    try {
      // setting the tabs
      return {
        id: `scrollable-auto-tab-${index}`,
        'aria-controls': `scrollable-auto-tabpanel-${index}`,
      };
    } catch (err) {
      console.log('err', err);
    }
  };
  useEffect(() => {
    const orgsFormData = orgState.orgsData;
    orgsFormData.packages = orgsFormData.packages
      ? [...orgsFormData.packages, PACKAGES.base]
      : [PACKAGES.base];
  }, [orgState.orgsData]);

  React.useEffect(() => {
    if (props.match && props.match.params.id) {
      getDetails(props.match.params.id);
    } else {
      orgAction.setOrgs({});
      userAction.setUserList([]);
    }
    orgAction.setAddedOrganizationId('');
  }, []);
  if (!orgState.orgsData?.shortname) return null;
  return (
    <Grid container direction="column">
      <DisplayBreadcrumbs items={breadcrumbsNav} />
      <Grid item sm={12}>
        <Grid
          container
          style={{
            padding: '50px 30px',
            margin: '0 -16px',
            wordBreak: 'break-all',
          }}
          spacing={2}
        >
          <Grid item sm={10}>
            <Typography variant="h6" component="h6">
              {orgState.orgsData?.shortname} - {orgState.orgsData?.title}
              <Tooltip
                title="Edit Tenant"
                style={{ marginLeft: 20, cursor: 'pointer' }}
              >
                <EditIcon color="primary" onClick={() => setOpen(true)} />
              </Tooltip>
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <Typography
              style={{
                cursor: 'pointer',
                fontSize: 14,
                width: 'fit-content',
                float: 'right',
              }}
              variant="h6"
              component="h6"
              onClick={() => history.push('/organization')}
            >
              <KeyboardBackspaceIcon style={{ position: 'relative', top: 7 }} />{' '}
              Back to List
            </Typography>
          </Grid>
          <Grid item sm={2}>
            <DisplayDate
              label="Effective Date"
              date={
                orgState.orgsData?.effectivedate
                  ? orgState.orgsData?.effectivedate
                  : null
              }
            />
          </Grid>
          <Grid item sm={2}>
            <DisplayDate
              label="End Date"
              date={
                orgState.orgsData?.inactivedate
                  ? orgState.orgsData?.inactivedate
                  : null
              }
            />
          </Grid>
          <Grid item sm={2}>
            Domain:{' '}
            {orgState.orgsData?.config?.allowed_domains
              ?.map((item) => item.domain)
              ?.join(',') || 'N/A'}
          </Grid>
          <Grid item sm={2}>
            Address :{' '}
            {[
              orgState.orgsData?.address,
              orgState.orgsData?.state,
              orgState.orgsData?.city,
              orgState.orgsData?.zipcode,
            ]
              .filter((item) => item != null && item !== '')
              .join(',')}
          </Grid>
        </Grid>
      </Grid>
      <Grid item sm={12}>
        <AppBar position="static">
          <Tabs
            className="tabsHeading"
            value={currentTab}
            onChange={(e, value) => setCurrentTab(value)}
            indicatorColor="secondary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="auto"
            aria-label="simple tabs example"
          >
            {TAB_LIST.map((v, k) => {
              return <Tab key={k} label={v} {...a11yProps(k)} />;
            })}
          </Tabs>
        </AppBar>
      </Grid>
      {currentTab == 0 && (
        <Grid style={{ padding: 50 }} item sm={12}>
          <OrgsUsers
            addedOrgsId={
              orgState.orgsData && orgState.orgsData.PK
                ? orgState.orgsData.PK
                : orgState.addedOrganizationId
            }
            pageType={'edit'}
          />
        </Grid>
      )}
      {currentTab == 1 && (
        <Grid item sm={12} style={{ padding: 50 }}>
          <OrgsProducts
            organizationData={orgState.orgsData}
            products={orgState.orgsData && orgState.orgsData.products ? orgState.orgsData.products : []}
            availableProduct={orgState.orgsData && orgState.orgsData.app_products ? orgState.orgsData.app_products : []}
            reloadOrg={() => getDetails(props.match.params.id)}
          />
        </Grid>
      )}
      <PopupModal open={open}>
        <OrganizationForm
          onClose={(type) => {
            if (type == globalPageTypeEntity.edit) {
              getDetails(props.match.params.id);
            }
            setOpen(false);
          }}
          type={globalPageTypeEntity.edit}
          formDate={{
            ...orgState.orgsData,
            allowed_domains: orgState?.orgsData?.config?.allowed_domains?.map(
              (item) => item.domain,
            ),
          }}
        />
      </PopupModal>
    </Grid>
  );
};
